import React from "react";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import CardHighlightFeatImage from "../../cards/cardHighlightFeatImage";

import "swiper/css/bundle";
import "swiper/css/navigation";

const CulturalImmersion = ({
  details,
  culturalPractices,
  conditionalSliderOpts
}) => {
  return (
    <>
      <div className={""}>
        <h3 className="heading text-left text-black-lighter dark:font-light pt-6 md:pt-2 mb-4">
          {details?.culturalLabel}
        </h3>
      </div>

      <div className="md:grid sm:grid-cols-2 gap-4 dark:gvi-light-gray-text text-sm">
        <ConditionalSwiper {...conditionalSliderOpts}>
          {culturalPractices?.map((item, idx) => (
            <CardHighlightFeatImage
              sourceUrl={item?.featuredImage?.node?.sourceUrl}
              featuredImage={
                item?.featuredImage?.node?.localFile?.extension
                  ? item?.featuredImage?.node?.localFile
                  : null
              }
              desc={item?.content}
              title={item?.title}
              key={`cultural-${idx}`}
              readMoreStatus={"hidden"}
              containerClasses={`${idx === 0 ? "sm:col-span-2 sm:mb-6 " : "sm:mb-6 "}`}
              hasCollapsibleWrapper={true}
            />
          ))}
        </ConditionalSwiper>
      </div>
    </>
  );
};

export default CulturalImmersion;
